import { Row as Bs5Row } from 'react-bootstrap5';

export default Bs5Row;
